// eslint-disable-next-line import/prefer-default-export
export const alwaysEqual = () => true;

export const arrayAreEqual = (array1, array2) => {
  const array1Length = array1.length;
  const array2Length = array2.length;

  if (array1Length !== array2Length) {
    return false;
  }

  const array1Map = {};

  for (let i = 0; i < array1Length; i += 1) {
    array1Map[array1[i]] = true;
  }

  for (let i = 0; i < array2Length; i += 1) {
    if (!array1Map[array2[i]]) {
      return false;
    }
  }

  return true;
};
